import React, { useState, useRef, useEffect } from "react";
import { FaEdit } from "react-icons/fa";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const MainImageCard = ({ project, onImageUpdate }) => {
  const [imageUrl, setImageUrl] = useState(project?.image || null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (project?.image?.trim()) {
      setImageUrl(`${project.image}?v=${Date.now()}`);
    } else {
      setImageUrl("https://via.placeholder.com/300");
    }
  }, [project?.image]);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!["image/jpeg", "image/png"].includes(file.type)) {
      alert("Only JPEG and PNG files are allowed.");
      return;
    }

    setImageUrl(URL.createObjectURL(file));
    onImageUpdate(file);
  };

  return (
    <div className="relative w-full max-w-[520px] mx-auto mt-6">
      <div className="w-full aspect-[13/9] rounded-2xl overflow-hidden shadow-md border border-gray-200">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Project"
            className="w-full h-full object-cover rounded-2xl"
          />
        ) : (
          <div className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-400 text-sm">
            No Image Available
          </div>
        )}
      </div>

      <button
        onClick={() => fileInputRef.current.click()}
        className="absolute top-2 right-2 bg-black bg-opacity-60 hover:bg-opacity-80 text-white p-2 rounded-full shadow-sm transition"
        title="Change Image"
      >
        <FaEdit size={14} />
      </button>

      <input
        type="file"
        accept="image/jpeg, image/png"
        ref={fileInputRef}
        className="hidden"
        onChange={handleFileSelect}
      />
    </div>
  );
};

export default MainImageCard;
